<template>
  <div class="row">
    <div class="col-md-9 order-2 order-md-1 padding-right-zero">
      <ConversationBody :id="id" :key="id"></ConversationBody>
    </div>
    <div class="col-md-3 order-1 order-md-2 text-center padding-left-zero">
      <ConversationList></ConversationList>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ConversationList from "./ConversationListComponent";
import ConversationBody from "./ConversationBodyComponent";

export default {
  props: ["id"],
  components: {
    ConversationList,
    ConversationBody
  },
  computed: {
    ...mapState(["user"])
  }
};
</script>

<style scoped>
.sidebar {
  right: 0px;
  position: relative;
  height: 80vh;
  overflow: hidden;
  /*overflow-y: auto;*/
  /*max-height: 80vh;*/
}
.padding-left-zero {
  padding-left: 0;
}
.padding-right-zero {
  padding-right: 0;
}
.main {
}

@media only screen and (max-device-width: 768px) {
  .sidebar {
    position: relative;
  }

  .content {
    display: -webkit-flex; /* Safari */
    -webkit-flex-flow: row-reverse wrap; /* Safari 6.1+ */
    display: flex;
    flex-flow: column-reverse wrap;
    margin: 0px;
  }

  .main {
  }
}
</style>
